import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { MixpanelService } from '../_services';

@Component({
  templateUrl: 'features.component.html'
})
export class FeaturesComponent implements OnInit {
  data: any = null;

  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    private mixpanelService: MixpanelService
  ) {
  }

  ngOnInit(): void {
    this.data = this.route.snapshot.data;
    this.mixpanelService.trackPageView(this.data.content.windowTitle);
    this.titleService.setTitle(this.data.content.windowTitle);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/features.component.ts